import React from 'react';
import Cropper from 'react-easy-crop';

interface ImageCropperProps {
  image: string;
  crop: { x: number; y: number };
  zoom: number;
  aspect?: number;
  onCropChange: (crop: { x: number; y: number }) => void;
  onZoomChange: (zoom: number) => void;
  onCropComplete: (croppedArea: any, croppedAreaPixels: any) => void;
}

const ImageCropper: React.FC<ImageCropperProps> = ({
  image,
  crop,
  zoom,
  aspect = 1,
  onCropChange,
  onZoomChange,
  onCropComplete,
}) => {
  return (
    <div style={{ position: 'relative', width: '100%', height: 400, background: '#333' }}>
      <Cropper
        image={image}
        crop={crop}
        zoom={zoom}
        aspect={aspect}
        onCropChange={onCropChange}
        onZoomChange={onZoomChange}
        onCropComplete={onCropComplete}
      />
    </div>
  );
};

export default ImageCropper;
